import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Main } from './Main';

export const AppRoutes = () => (
    <Router>
        <Routes>
            <Route index path={"/"} element={<Main/>} />
        </Routes>
    </Router>
)